// extracted by mini-css-extract-plugin
export default {"dialog":"WishBoxModal_dialog__KfIYu","modal":"WishBoxModal_modal__dzOz1"};